'use strict'

var DAY = 86400000
var HALF_DAY = DAY / 2
var UNIX_EPOCH_JULIAN_DATE = 2440587.5
var UNIX_EPOCH_JULIAN_DAY = 2440587

var Julian = {

  convert: function (date) {
    return (this.toJulianDay(date) + (this.toMillisecondsInJulianDay(date) / DAY)).toFixed(6)
  },

  convertToDate: function (julian) {
    return new Date((Number(julian) - UNIX_EPOCH_JULIAN_DATE) * DAY)
  },

  convertToISOString: function (julian) {
    return (new Date((Number(julian) - UNIX_EPOCH_JULIAN_DATE) * DAY)).toISOString()
  },

  toJulianDay: function (date) {
    return ~~((+date + HALF_DAY) / DAY) + UNIX_EPOCH_JULIAN_DAY
  },

  toMillisecondsInJulianDay: function (date) {
    return (+date + HALF_DAY) % DAY
  },

  fromJulianDayAndMilliseconds: function (day, ms) {
    return (day - UNIX_EPOCH_JULIAN_DATE) * DAY + ms
  }
}

// Make it available globally for legacy code
window.Julian = Julian

export default Julian
